import React, { memo } from 'react'
import ANCHORS from 'root/src/shared/constants/anchors'
import Anchor from 'root/src/client/web/base/Anchor'

const Anchors = memo(({ classes }) => (
	<div className={classes.listWrapper}>
		<ul className={classes.listOfLinks}>
			<li>
				<Anchor anchor={ANCHORS.CHANGE_POLICY}>
					Changes to This Policy
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.WHO_WE_ARE}>
					Who We Are
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.HOW_APPLIES}>
					How This Policy Applies
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.COLLECT_AND_RECIVE}>
					What We Collect and Receive
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.HOW_USE_INFO}>
					How We Use This Information
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.UNION_USER}>
					European Union Users
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.HOW_SHARE}>
					How This Information Is Shared
				</Anchor>
			</li>
			<ul className={classes.listOfLinks}>
				<li>
					<Anchor anchor={ANCHORS.SHARED_PUBLICY}>
						Information that’s shared publicly
					</Anchor>
				</li>
				<li>
					<Anchor anchor={ANCHORS.NOT_SHARED_PUBLICY}>
						Information that isn’t shared publicly
					</Anchor>
				</li>
				<li>
					<Anchor anchor={ANCHORS.SHARED_WITH_TRUSTED}>
						Information that’s shared with trusted third-party services
					</Anchor>
				</li>
				<li>
					<Anchor anchor={ANCHORS.SHARED_WITH_CREATORS}>
						Information that’s shared with creators and collaborators
					</Anchor>
				</li>
				<li>
					<Anchor anchor={ANCHORS.SHARED_WITH_DARE_DROP}>
						Information that’s shared to protect Dare Drop and comply with the law
					</Anchor>
				</li>
				<li>
					<Anchor anchor={ANCHORS.LINKS_TO_SERVICE}>
						Links to other websites and services
					</Anchor>
				</li>
			</ul>

			<li>
				<Anchor anchor={ANCHORS.RETENTION}>
					Retention
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.DATA_TRANSFER}>
					Data Transfers
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.RIGHTS}>
					Your Rights
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.NOTIFICATION}>
					Email and Mobile Notifications
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.SECURE}>
					Security
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.DATA_PROTECT_OFFICER}>
					Data Protection Officer
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.DATA_PROTECT_AUTHORITY}>
					Data Protection Authority
				</Anchor>
			</li>
			<li>
				<Anchor anchor={ANCHORS.CHILDREN}>
					Children
				</Anchor>
			</li>
		</ul>
	</div>
))

export default Anchors
